// extracted by mini-css-extract-plugin
export default {"registration-success-content":"styles-module_registration-success-content---BWBA_"};